import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Input from "../../components/Input";
import CancelarButton from "../../components/CancelarButton";
import { selectUserToken } from "../../features/user";
import useAccessProfile from "../../hooks/useAccessProfile";
import { useEffect } from "react";
import { useState } from "react";
import useRequest, { Status } from "../../hooks/useRequest";
import Loading from "../../components/Loading";
import divisaoApi from "../../utility/api/divisaoApi";
import departamentoApi from "../../utility/api/departamentoApi";
import Dropdown from "../../components/Dropdown";
import Toggle from "../../components/Toggle";
import { NotAllowed } from "../NotAllowed";
import { useTranslation } from "react-i18next";

const CadastroDepartamento = () => {
  const { t } = useTranslation();
  const token = useSelector(selectUserToken);
  const navigate = useNavigate();
  const {
    handleSubmit,
    watch,
    getValues,
    reset,
    register,
    setValue,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [divisions, setDivisions] = useState();

  const { isManager } = useAccessProfile();

  const divisionsRequest = useRequest(() => divisaoApi.listarDropdown(token));
  const createDepartmentRequest = useRequest((data) =>
    departamentoApi.cadastrarDepartamento(data, token)
  );

  useEffect(() => {
    divisionsRequest.execute();
  }, []);

  useEffect(() => {
    if (divisionsRequest.data) {
      setDivisions(
        divisionsRequest.data.map((item) => ({
          value: item.id,
          text: item.name,
        }))
      );
    }
  }, [divisionsRequest.data]);

  useEffect(() => {
    setLoading(createDepartmentRequest.status === Status.Loading);

    if (createDepartmentRequest.status === Status.Success) {
      resetForm();
      Swal.fire({
        title: `${t('addOrUpdateUser.modalSucess.title')}`,
        text: `${t('addOrUpdateUser.modalSucess.text')}`,
        icon: "success",
      });
      navigate("/departamento/listagem");
    }

    if (createDepartmentRequest.status === Status.Failed) {
      Swal.fire({
        title: `${t('components.attention')}`,
        text: createDepartmentRequest.data || "Algo deu errado",
        icon: "info",
      });
    }
  }, [createDepartmentRequest.status]);

  const onSubmit = (data) => {
    createDepartmentRequest.execute({
      description: data.name,
      divisionId: data.divisionId,
      hasSCI: data.hasSCI,
    });
  };

  const resetForm = useCallback(() => {
    Swal.fire({
      text: `${t('components.msgConfirmCancel')}`,
      showDenyButton: true,
      confirmButtonText: `${t('modalUser.yes')}`,
      denyButtonText: `${t('modalUser.no')}`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        reset({
          divisionId: "",
          name: "",
        });

        Swal.fire({
          text: `${t('components.msgCancel')}`,
          icon: "success",
        });
      }
    });
  }, [reset, t]);

  function withRequestStatus(request, value) {
    const isLoading =
      request.status === Status.Idle || request.status === Status.Loading;
    const hasError = request.status === Status.Failed;
    if (isLoading) {
      return `${t('components.loading')}`;
    }
    if (hasError) {
      return `${t('error')}`;
    }
    return value;
  }

  if (!isManager) return <NotAllowed />;

  return (
    <>
      {loading && <Loading isVisible={true} />}
      <form onSubmit={handleSubmit(onSubmit)} className="">
        <div className="w-full min-h-screen flex flex-col pb-[60px]">
          <div className="flex flex-col justify-center pt-[100px] mx-[15%]">
            <div className="mb-4 text-[24px] font-semibold text-[#1B2646]">
              {t('addOrUpdateDepartment.add.title')}
            </div>
            <div className="flex flex-col gap-5">
              <div>
                <label>{t('addOrUpdateDepartment.add.fields.division.label')}</label>
                <Dropdown
                  name="divisionId"
                  defaultText={withRequestStatus(
                    divisionsRequest,
                    `${t('addOrUpdateDepartment.add.fields.division.placeholder')}`
                  )}
                  options={divisions}
                  py="py-[8px]"
                  width={"w-full"}
                  setValue={setValue}
                  watch={watch}
                  getValues={getValues}
                  required
                  register={register}
                  errors={errors}
                />
              </div>
              <div>
                <label>{t('addOrUpdateDepartment.add.fields.description.label')}</label>
                <Input
                  name="name"
                  register={register}
                  errors={errors}
                  required={true}
                />
              </div>
              <div>
                <label>{t('addOrUpdateDepartment.add.fields.haveSCI')}</label>
                <Toggle
                  name="hasSCI"
                  setValue={setValue}
                  watch={watch}
                  getValues={getValues}
                  register={register}
                />
              </div>
            </div>
          </div>

          <div className="flex justify-center mt-6">
            <div className="w-[70%] undefined bg-white rounded-md border border-[#ECECEC] py-4 flex items-center justify-between px-11">
              <CancelarButton
                voltar={() => navigate("/departamento/listagem")}
                watch={watch}
                getValues={getValues}
                reset={resetForm}
                wide
              />
              <button className="w-[181px] h-[44px] bg-[#187733] text-white rounded-[4px]">
                {t('components.buttons.save')}
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default CadastroDepartamento;
